import { useEffect, useState } from 'react';
import { Button, Col, Form as FormB, FormCheck, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { addUsuarioComite, cleanUsuario, useComite } from '../../../../../../appStore/comite';
import { GREMIOS } from '../../../../../../const';
import Form from '../../../../../CompUtils/Form';
import { RolComite } from './ComiteRow';
import { CuilSearchInput } from './CuilSearchInput';

type StyleProps = Partial<{ little: boolean }>;
const Root = styled.div`
  width: 780px;
  max-height: 480px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0px 5px;
`;

const NoMarginRow = styled(Row)<StyleProps>`
  margin-bottom: ${({ little }) => (little ? '-16px' : '-40px')};
`;

export type NuevoComiteFormValues = {
  titular: string;
  cuil: string;
  apellido: string;
  nombre: string;
  dni: string;
  telefono: string;
  email: string;
  pathCvProvisto: string | File;
};

/* const { Form } = createFormCtx<NuevoComiteFormValues>(); */
type Props = RolComite & { onClose: () => void };
export const NuevoComiteMiembro = (props: Props) => {
  const [isNewUser, setIsNewUser] = useState(false);
  const { onClose, ...rolComite } = props;

  const dispatch = useDispatch();
  const { usuario } = useComite();
  const [valuesUsuario, setValuesUsuario] = useState({
    cuil: '',
    apellido: '',
    nombre: '',
    email: '',
    dni: '',
    telefono: '',
  });
  const [values] = useState({
    titular: false,
    alterno: false,
    representacion: '',
  });
  const [cv, setCv] = useState<any>();

  const handleSubmit = () => {
    if (usuario !== undefined)
      dispatch(
        addUsuarioComite({
          usuario,
          valores: {
            ...valuesUsuario,
            titular: values.titular ? 'titular' : 'alterno',
            pathCvProvisto: cv,
          },
          rolComite,
        }),
      );
  };

  useEffect(
    () => () => {
      dispatch(cleanUsuario());
    },
    [dispatch],
  );

  return (
    <Root>
      <Form
        disableBtns={usuario === undefined}
        extraBtns={[
          <Button key="cancelar" variant="link" onClick={onClose}>
            Cancelar
          </Button>,
        ]}
        size="full"
        onSubmit={handleSubmit}
        submitText={'Aceptar'}
        btns={['submit']}>
        <NoMarginRow>
          <Col xs={5}>
            <FormB.Group>
              <FormB.Label>Designación</FormB.Label>
              <FormCheck type="radio" id="titular" name="titular" title="Titular" />
            </FormB.Group>
            <FormCheck type="radio" name="titular" id="alterno" title="Alterno" />
          </Col>
        </NoMarginRow>
        <NoMarginRow little>
          <CuilSearchInput
            onUsuario={(usuario, cuil) => {
              setIsNewUser(!usuario);
              if (usuario === null) {
                setValuesUsuario({
                  cuil: '',
                  apellido: '',
                  nombre: '',
                  email: '',
                  dni: '',
                  telefono: '',
                });
              } else {
                setValuesUsuario({
                  ...usuario,
                });
              }
            }}
          />
          <Col xs={6}>
            <FormB.Group>
              <FormB.Label>Representación</FormB.Label>
              <FormB.Control as="select">
                <option value={GREMIOS.ATE}>{GREMIOS.ATE}</option>
                <option value={GREMIOS.UPCN}>{GREMIOS.UPCN}</option>
                <option value={GREMIOS.MINMUJ}>{GREMIOS.MINMUJ}</option>
                <option value={GREMIOS.MINTRA}>{GREMIOS.MINTRA}</option>
              </FormB.Control>
            </FormB.Group>
            {/*             <SelectInput
              hide={idRolComite !== 6}
              id="representacion"
              title="Representación"
              options={[
                { id: GREMIOS.ATE },
                { id: GREMIOS.UPCN },
                { id: GREMIOS.MINMUJ },
                { id: GREMIOS.MINTRA },
              ]}
            /> */}
          </Col>
        </NoMarginRow>
        {isNewUser && (
          <>
            <NoMarginRow little>
              <p className="error" style={{ marginLeft: 16 }}>
                Usuario no encontrado. Realizar registro en el siguiente formulario
              </p>
            </NoMarginRow>
            <NoMarginRow little>
              <Col xs={6}>
                <FormB.Control
                  type="text"
                  id="apellido"
                  title="Apellido"
                  value={valuesUsuario.apellido}
                  onChange={(e) => {
                    setValuesUsuario({ ...valuesUsuario, apellido: e.target.value });
                  }}
                  //validate={Yup.string().required()}
                />
              </Col>
              <Col xs={6}>
                <FormB.Control
                  type="text"
                  id="nombre"
                  title="Nombre"
                  value={valuesUsuario.nombre}
                  onChange={(e) => {
                    setValuesUsuario({ ...valuesUsuario, nombre: e.target.value });
                  }}
                  //validate={Yup.string().required()}
                />
              </Col>
            </NoMarginRow>
            <NoMarginRow little>
              <Col xs={6}>
                <FormB.Control
                  type="number"
                  id="dni"
                  title="DNI"
                  value={valuesUsuario.dni}
                  onChange={(e) => {
                    setValuesUsuario({ ...valuesUsuario, dni: e.target.value });
                  }}
                  //validate={Yup.string().required()}
                />
              </Col>
              <Col xs={6}>
                <FormB.Control
                  id="telefono"
                  title="Teléfono"
                  type="number"
                  value={valuesUsuario.telefono}
                  onChange={(e) => {
                    setValuesUsuario({ ...valuesUsuario, telefono: e.target.value });
                  }}
                  //validate={Yup.string().required()}
                />
              </Col>
            </NoMarginRow>
            <NoMarginRow little>
              <Col xs={12}>
                <FormB.Control
                  type="text"
                  id="email"
                  title="Correo electrónico"
                  value={valuesUsuario.email}
                  onChange={(e) => {
                    setValuesUsuario({ ...valuesUsuario, email: e.target.value });
                  }}
                  //validate={Yup.string().email('El correo ingresado no es válido').required()}
                />
              </Col>
            </NoMarginRow>
            <NoMarginRow little>
              <Col xs={10}>
                <FormB.Group>
                  <FormB.Label>CV</FormB.Label>
                  <FormB.File
                    id="pathCvProvisto"
                    accept=".pdf"
                    name="cv"
                    type="file"
                    onChange={(ev: any) => {
                      setCv(ev.currentTarget.files[0]);
                    }}
                    /* hide={!isNewUser && !usuario}
              validate={Yup.string().nullable().required()} */
                  />
                  <FormB.File.Label data-browse="Cargar archivo">{cv?.name}</FormB.File.Label>
                </FormB.Group>
              </Col>
            </NoMarginRow>
          </>
        )}
      </Form>
    </Root>
  );
};
